module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av115-7a00cb95ac9f676577dd1fa00666107b.jpg";